/* ECAS paid-media landing behavior: wall builder + sticky CTA.
   Adds items as independent cart line items via the Ajax API; the quantity
   discount itself is a native automatic discount applied by Shopify at
   checkout — nothing here fakes pricing. */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]+>/g, '');
  };

  /* ---------------- wall builder ---------------- */
  document.querySelectorAll('[data-ecas-builder]').forEach(function (root) {
    var slots = Array.prototype.slice.call(root.querySelectorAll('[data-ecas-slot]'));
    var totalEl = root.querySelector('[data-ecas-total]');
    var ctaEl = root.querySelector('[data-ecas-cta]');
    if (!slots.length || !totalEl || !ctaEl) return;

    var t1q = parseInt(root.dataset.tier1Qty, 10) || 3;
    var t1p = parseInt(root.dataset.tier1Pct, 10) || 10;
    var t2q = parseInt(root.dataset.tier2Qty, 10) || 5;
    var t2p = parseInt(root.dataset.tier2Pct, 10) || 20;
    var emptyTotal = totalEl.textContent;
    var emptyCta = ctaEl.textContent;
    var slotLabels = slots.map(function (el) { return el.innerHTML; });
    var picked = slots.map(function () { return null; });

    function findPickBtn(variant) {
      return root.querySelector('[data-ecas-pick][data-variant="' + variant + '"]');
    }

    function render() {
      var n = picked.filter(Boolean).length;
      picked.forEach(function (item, i) {
        var el = slots[i];
        if (i >= 3) {
          var show = n >= i || !!item;
          el.classList.toggle('ecas-slot--hidden', !show);
        }
        if (item) {
          el.classList.add('ecas-slot--filled');
          el.innerHTML = '<img src="' + item.img + '" alt=""><span class="ecas-slot__rm" aria-hidden="true">&times;</span>';
          el.setAttribute('aria-label', 'Wall slot ' + (i + 1) + ': ' + item.title + '. Tap to remove.');
        } else {
          el.classList.remove('ecas-slot--filled');
          el.innerHTML = slotLabels[i];
          el.setAttribute('aria-label', 'Wall slot ' + (i + 1) + ', empty');
        }
      });
      root.querySelectorAll('[data-ecas-pick]').forEach(function (btn) {
        var isPicked = picked.some(function (it) { return it && String(it.variant) === btn.dataset.variant; });
        btn.setAttribute('aria-pressed', isPicked ? 'true' : 'false');
      });

      if (n === 0) {
        totalEl.textContent = emptyTotal;
        ctaEl.textContent = emptyCta;
        ctaEl.setAttribute('disabled', '');
        return;
      }
      var total = picked.filter(Boolean).reduce(function (s, it) { return s + it.price; }, 0);
      var line = n + (n === 1 ? ' print' : ' prints') + ' — from <b>' + money(total) + '</b>';
      if (n === t1q - 1) {
        line += ' <span class="ecas-free">· add 1 more for an extra ' + t1p + '% off</span>';
      } else if (n >= t1q && n < t2q) {
        line += ' <span class="ecas-free">· extra ' + t1p + '% off at checkout → from ' + money(Math.round(total * (100 - t1p) / 100)) + (n === t2q - 1 ? ' · add 1 more for an extra ' + t2p + '%' : '') + '</span>';
      } else if (n >= t2q) {
        line += ' <span class="ecas-free">· extra ' + t2p + '% off at checkout → from ' + money(Math.round(total * (100 - t2p) / 100)) + '</span>';
      } else {
        line += ' <span class="ecas-free">· ships free</span>';
      }
      totalEl.innerHTML = line;
      ctaEl.textContent = 'Add ' + n + (n === 1 ? ' print' : ' prints') + ' to cart — from ' + money(total);
      ctaEl.removeAttribute('disabled');
    }

    function addItem(item) {
      if (picked.some(function (it) { return it && String(it.variant) === String(item.variant); })) return;
      var free = picked.indexOf(null);
      if (free === -1) return;
      picked[free] = item;
      render();
    }

    slots.forEach(function (el, i) {
      el.addEventListener('click', function () {
        if (!picked[i]) return;
        picked[i] = null;
        render();
      });
    });

    root.querySelectorAll('[data-ecas-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addItem({
          variant: btn.dataset.variant,
          price: parseInt(btn.dataset.price, 10) || 0,
          title: btn.dataset.title,
          img: btn.dataset.img
        });
      });
    });

    root.querySelectorAll('[data-ecas-set]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var items;
        try { items = JSON.parse(btn.dataset.ecasSet); } catch (e) { return; }
        items.forEach(addItem);
      });
    });

    /* predictive search → pickable result chips */
    var searchInput = root.querySelector('[data-ecas-search]');
    var resultsEl = root.querySelector('[data-ecas-results]');
    if (searchInput && resultsEl && window.theme && window.theme.routes && window.theme.routes.predictiveSearch) {
      var debounce;
      searchInput.addEventListener('input', function () {
        clearTimeout(debounce);
        var q = searchInput.value.trim();
        if (q.length < 2) { resultsEl.innerHTML = ''; return; }
        debounce = setTimeout(function () {
          var url = window.theme.routes.predictiveSearch +
            '?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide';
          fetch(url, { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
              resultsEl.innerHTML = '';
              prods.forEach(function (p) {
                var chip = document.createElement('button');
                chip.type = 'button';
                chip.className = 'ecas-set-chip';
                var img = p.featured_image && (p.featured_image.url || p.image);
                chip.innerHTML = (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
                  p.title.replace(/</g, '&lt;');
                chip.addEventListener('click', function () {
                  /* predictive search returns no variant id — resolve via the product endpoint */
                  fetch(p.url.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
                    .then(function (r) { return r.json(); })
                    .then(function (full) {
                      var v = full.variants && full.variants[0];
                      if (!v) return;
                      addItem({
                        variant: v.id,
                        price: v.price,
                        title: full.title,
                        img: (full.images && full.images[0]) || img || ''
                      });
                      resultsEl.innerHTML = '';
                      searchInput.value = '';
                    });
                });
                resultsEl.appendChild(chip);
              });
              if (!prods.length) {
                resultsEl.innerHTML = '<p class="ecas-builder__micro">No exact match yet — try another spelling, or browse the picks below.</p>';
              }
            })
            .catch(function () { /* leave results as-is on network error */ });
        }, 250);
      });
    }

    ctaEl.addEventListener('click', function () {
      var items = picked.filter(Boolean).map(function (it) {
        return { id: parseInt(it.variant, 10), quantity: 1 };
      });
      if (!items.length) return;
      ctaEl.setAttribute('disabled', '');
      ctaEl.textContent = 'Adding…';
      fetch((window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = root.dataset.cartUrl || '/cart';
        })
        .catch(function () {
          ctaEl.removeAttribute('disabled');
          ctaEl.textContent = 'Try again — something went wrong';
        });
    });

    render();
  });

  /* ---------------- ad-concept message match (?c=) ---------------- */
  (function () {
    var hero = document.querySelector('[data-ecas-hero]');
    var configEl = hero && hero.querySelector('[data-ecas-concepts]');
    if (!hero || !configEl) return;
    var param = new URLSearchParams(location.search).get('c');
    if (!param) return;
    var concepts;
    try { concepts = JSON.parse(configEl.textContent); } catch (e) { return; }
    var c = concepts.find(function (x) { return x.param === param.toLowerCase(); });
    if (!c) return;
    var set = function (sel, val, html) {
      var el = hero.querySelector(sel);
      if (el && val) { if (html) { el.innerHTML = val; } else { el.textContent = val; } }
    };
    set('[data-ecas-hero-eyebrow]', c.eyebrow);
    set('[data-ecas-hero-h1]', c.h1, true);
    set('[data-ecas-hero-sub]', c.sub);
    if (c.placeholder) {
      var input = hero.querySelector('[data-ss-input]');
      if (input) input.setAttribute('placeholder', c.placeholder);
    }
    if (c.cta) {
      document.querySelectorAll('[data-ecas-sticky-cta]').forEach(function (el) { el.textContent = c.cta; });
    }
    try { sessionStorage.setItem('ecas_concept', c.param); } catch (e) { /* private mode */ }
  })();

  /* ---------------- sticky CTA ---------------- */
  document.querySelectorAll('[data-ecas-sticky]').forEach(function (bar) {
    var showAfter = parseInt(bar.dataset.showAfter, 10) || 520;
    var ticking = false;
    function update() {
      bar.classList.toggle('ecas-sticky--visible', window.scrollY > showAfter);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
    var cta = bar.querySelector('[data-ecas-sticky-cta]');
    if (cta && (cta.getAttribute('href') || '').charAt(0) === '#') {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        var heroInput = document.querySelector('.hero-search input[type="search"], .text-hero input[type="search"]');
        if (heroInput) heroInput.focus({ preventScroll: true });
      });
    }
  });
})();
